<template>
  <v-dialog v-model="dialog" persistent width="620" scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>HỆ ĐÀO TẠO QUAN TÂM</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <div v-for="(product, index) in products" :key="product.id">
          <div class="d-flex justify-space-between pb-6">
            <v-select
              :items="product.selections"
              item-text="name"
              item-value="id"
              v-model="localProfile.products[index]"
              :label="`Chọn hệ đào tạo quan tâm ${index + 1}`"
              return-object
              outlined
              hide-details
            />
            <v-icon class="ml-6" @click="removeProduct(index)">mdi-trash-can</v-icon>
          </div>
        </div>
        <div class="d-flex justify-space-between">
          <v-spacer></v-spacer>
          <v-btn outlined color="blue darken-4" @click="addProduct">Thêm</v-btn>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" @click="cancel" outlined>Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="confirmSelection">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    profile: Object,
    items: Array,
  },
  data() {
    return {
      selectedProduct: null,
      localProfile: {},
      products: [],
    }
  },
  watch: {
    profile: {
      immediate: true,
      handler(newProfile) {
        if (newProfile) {
          this.localProfile = JSON.parse(JSON.stringify(newProfile))
          this.setFormValues(this.localProfile)
        }
      },
    },
    'profile.products': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.localProfile.products = newVal.map((item) => ({ ...item }))
          this.products = newVal.map((item, index) => ({ ...item, selections: this.getAvailableProducts(index) }))
        } else {
          this.localProfile.products = [{}]
          this.products = []
        }
      },
      deep: true,
    },
  },
  methods: {
    confirmSelection() {
      const isProductEmpty = (product) => {
        return !product || Object.keys(product).length === 0 || !product.id
      }
      const filteredProducts = this.localProfile.products.filter((product) => !isProductEmpty(product))

      this.$emit('confirm', filteredProducts)
      this.$emit('closeProduct', false)
    },
    cancel() {
      this.$emit('closeProduct', false)
    },
    addProduct() {
      this.localProfile.products.push('')
    },
    removeProduct(index) {
      if (this.localProfile.products.length > 1) {
        this.localProfile.products.splice(index, 1)
      } else {
        this.$set(this.localProfile.products, index, {})
      }
    },
    setFormValues(profile) {
      if (profile.products && profile.products.length > 0) {
        this.localProfile.products = profile.products
      } else {
        this.localProfile.products = [{}]
      }
    },
    getAvailableProducts(index) {
      const currentProductId = this.localProfile.products[index].id
      return this.items.filter(
        (product) =>
          product.id === currentProductId ||
          !this.localProfile.products.some((selectedProduct) => selectedProduct.id === product.id)
      )
    },
  },
}
</script>
